import React, { useCallback, useState } from 'react';

import PropTypes from 'prop-types';
import SocialSharingList from 'ggApp/shared/components/SocialSharingList';
import { StyledModal } from './styles';

const ProductSharerModal = ({
    modalRef,
    isMobile,
    link,
    message,
    needsDefaultCopy,
    onCancel,
    onShared,
    isReferralModal,
}) => {
    const [modal, setModal] = useState(null);
    const createModalRef = useCallback(
        (newModal) => {
            setModal(newModal);
            modalRef(newModal);
        },
        [modalRef],
    );
    const closeModal = useCallback(
        ({ isShared }) => {
            if (modal) {
                modal.closeModal({ isShared });
            }
        },
        [modal],
    );
    const onClickItem = useCallback(
        (networkName) => {
            onShared(networkName);
            closeModal({ isShared: true });
        },
        [closeModal, onShared],
    );

    const handleClose = useCallback(
        ({ isShared }) => {
            if (isShared) {
                return;
            }
            onCancel();
        },
        [onCancel],
    );

    return (
        <StyledModal modalRef={createModalRef} onClose={handleClose}>
            <SocialSharingList
                link={link}
                message={message}
                needsTitle={false}
                needsDefaultCopy={needsDefaultCopy}
                isMobile={isMobile}
                onClickItem={onClickItem}
                isReferralModal={isReferralModal}
                page="pdp"
            />
        </StyledModal>
    );
};

ProductSharerModal.propTypes = {
    modalRef: PropTypes.func,
    isMobile: PropTypes.bool,
    needsDefaultCopy: PropTypes.bool,
    link: PropTypes.string.isRequired,
    message: PropTypes.string,
    onShared: PropTypes.func,
    onCancel: PropTypes.func,
    isReferralModal: PropTypes.bool,
};

ProductSharerModal.defaultProps = {
    modalRef: () => {},
    isMobile: true,
    needsDefaultCopy: true,
    message: '',
    isReferralModal: false,
    onShared: () => {},
    onCancel: () => {},
};

export default ProductSharerModal;
